import { CountriesJSON } from "../../components/shared/countriesJSON";

export const getAlpha2Code = (countryName) => {
    if (!countryName || typeof countryName !== "string") {
        return null;
    }

    // Convert countryName to lowercase for case-insensitive comparison
    const lowercaseCountryName = countryName.trim().toLowerCase();

    // Use the filter method to find the matching country
    const matchingCountry = CountriesJSON.filter(country => {
        // Check if the country object has the "Country/Region" property
        if (country && country["Country"]) {
            // Convert the country name in the data to lowercase for comparison
            const lowercaseCountry = country["Country"].toLowerCase();
            return lowercaseCountry === lowercaseCountryName;
        }
        return false;
    });

    // If a matching country is found, return its Alpha-2 code
    if (matchingCountry.length > 0) {
        return matchingCountry[0]["Alpha-2 code"];
    } else {
        // If the country is not found, return null
        return null;
    }
}

